import { Component, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
import { Subject } from "rxjs";
import { UtilsService } from 'app/core/util/view-file.component';

@Component({
  selector: 'cbic-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {
  color:any;
  flag: any;
  year :any;
  newsLettersDataList?: ICbicContentMst[]|null|undefined;

  monthList?:ICbicContentMst[];
  monthListSubscriber = new Subject<ICbicContentMst[]>();

  newsletters?:ICbicContentMst[];
  newslettersSubscriber = new Subject<ICbicContentMst[]>();

  constructor(private sessionStorageService: SessionStorageService
    ,private contentMstService: CbicContentMstService
    , private changeLnService: ChangeLanguageService,public utils: UtilsService) { }
  isDataAvailable(){
    let dataAvailable = true;
    dataAvailable &&= this.newsLettersDataList !=null;
    return dataAvailable;
   };
  ngOnInit(): void {
    this.getnewsLetter();
    this.color = this.sessionStorageService.retrieve('colr');
    this.monthListSubscriber.subscribe((value:ICbicContentMst[])=>{
      this.monthList = value;
    });
    this.newslettersSubscriber.subscribe((value:ICbicContentMst[])=>{
      this.newsletters = value;
    })
  }

  getnewsLetter(): void {
    this.contentMstService.getContentNewsLetterData().subscribe( 
      (res: HttpResponse<ICbicContentMst>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          const data:ICbicContentMst = res.body;
          this.newsLettersDataList = data.childContentList;
          if(this.newsLettersDataList && this.newsLettersDataList.length > 0){
            this.updateMonthList(this.newsLettersDataList[0].id);
          }
        }
      }
    )
  }

  updateMonthList(year:any){
    this.contentMstService.findById(btoa(year)).subscribe( 
      (res: HttpResponse<ICbicContentMst>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          const data:ICbicContentMst[] = res.body.childContentList??[];

          this.monthListSubscriber.next(data);

          //updateNewsLetters
          if(data && data.length > 0){
            this.updateNewsLetters(data[0].id);
          }
        }
    });
  }

 

  updateNewsLetters(month:any){
    this.contentMstService.findById(btoa(month)).subscribe( 
      (res: HttpResponse<ICbicContentMst>) => {
        if (res.body) {
          const usedLanguage = this.changeLnService.getLanguage();
          if (usedLanguage === 'hi') {
            this.flag ='Hi';
          } else {
            this.flag = 'En';
          }
          const data:ICbicContentMst[] = res.body.childContentList??[];
          this.newslettersSubscriber.next(data);
        }
    });
  }

  
  updateMonthListener(evt: any){
    const year = evt.target.value;
    if(!year){
      return;
    } 
    this.updateMonthList(year);
  }
  
  updateNewsLettersListener(evt: any){
    const month = evt.target.value;
    if(!month){
      return;
    } 
    this.updateNewsLetters(month);
  }

  ViewPdf(filePath: any) {
    this.utils.viewOpenning(filePath);
  }
  
}
